export class Holerite {
  id: number = null;
  base: number = null;
  anoFol: number = null;
  mesFol: number = null;
  seqFol: number = null;
  anotacaoFol: string = null;
  opcao: string = null;
  campoexibicao: string = null;
  campovalor: string = null;
  nrCodigoBancoVinculada: number = null;
  txtCodigoAgenciaVinculada: string = null;
  txtContaPessoaVinculada: string = null;
  dsNomeAgenciaVinculada: string = null;
  dtObtencaoDado: Date = null;
  incorporacoes: string = null;
  ferias: string = null;
  licencas: string = null;
  funcoes: string = null;
  referencias: string = null;
  substituicoes: string = null;
  anotacaoIndividual: string = null;
  previa: string = null;
  tipo: string = null;
  holerite: Blob = null;
  txtOperacaoContaVinculada: string = null;
  dsNomeBancoVinculada: string = null;
  anuenios: string = null;

  constructor(d?) {
    if (d) {
      this.id = d.id ? d.id : null;
      this.base = d.base ? d.base : null;
      this.anoFol = d.anoFol ? d.anoFol : null;
      this.mesFol = d.mesFol ? d.mesFol : null;
      this.seqFol = d.seqFol ? d.seqFol : null;
      this.anotacaoFol = d.anotacaoFol ? d.anotacaoFol : null;
      this.opcao = d.opcao ? d.opcao : null;
      this.campoexibicao = d.campoexibicao ? d.campoexibicao : null;
      this.campovalor = d.campovalor ? d.campovalor : null;
      this.nrCodigoBancoVinculada = d.nrCodigoBancoVinculada
        ? d.nrCodigoBancoVinculada
        : null;
      this.txtCodigoAgenciaVinculada = d.txtCodigoAgenciaVinculada
        ? d.txtCodigoAgenciaVinculada
        : null;
      this.txtContaPessoaVinculada = d.txtContaPessoaVinculada
        ? d.txtContaPessoaVinculada
        : null;
      this.dsNomeAgenciaVinculada = d.dsNomeAgenciaVinculada
        ? d.dsNomeAgenciaVinculada
        : null;
      this.dtObtencaoDado = d.dtObtencaoDado ? d.dtObtencaoDado : null;
      this.incorporacoes = d.incorporacoes ? d.incorporacoes : null;
      this.ferias = d.ferias ? d.ferias : null;
      this.licencas = d.licencas ? d.licencas : null;
      this.funcoes = d.funcoes ? d.funcoes : null;
      this.referencias = d.referencias ? d.referencias : null;
      this.substituicoes = d.substituicoes ? d.substituicoes : null;
      this.anotacaoIndividual = d.anotacaoIndividual
        ? d.anotacaoIndividual
        : null;
      this.previa = d.previa ? d.previa : null;
      this.tipo = d.tipo ? d.tipo : null;
      this.holerite = d.holerite ? d.holerite : null;
      this.txtOperacaoContaVinculada = d.txtOperacaoContaVinculada
        ? d.txtOperacaoContaVinculada
        : null;
      this.dsNomeBancoVinculada = d.dsNomeBancoVinculada
        ? d.dsNomeBancoVinculada
        : null;
      this.anuenios = d.anuenios ? d.anuenios : null;
    }
  }

  nomeArquivo(nome?: string): string {
    let nomeAux: string = '';

    if (nome) {
      nomeAux = nome;
    }

    return (
      nomeAux +
      'Holerite' +
      this.anoFol +
      '-' +
      this.mesFol +
      '-' +
      this.seqFol +
      '(' +
      this.id +
      ').pdf'
    );
  }
}
